var map = {
	"./icon-android.svg": "1ee8",
	"./icon-apple.svg": "aaa1",
	"./icon-arrow-backward.svg": "cb7f",
	"./icon-arrow-forward.svg": "10b0",
	"./icon-check.svg": "dc7b",
	"./icon-download.svg": "ae39",
	"./icon-edit-dark.svg": "10c9",
	"./icon-edit.svg": "d5ef",
	"./icon-mobile-menu.svg": "c005",
	"./icon-moile-menu.svg": "9898",
	"./icon-ocr-dark.svg": "49e2",
	"./icon-ocr.svg": "87d7",
	"./icon-quote.svg": "8d75",
	"./icon-scan-dark.svg": "290f",
	"./icon-scan.svg": "f2a9",
	"./icon-scanner-logo.svg": "b528",
	"./icon-search.svg": "6819",
	"./icon-share-dark.svg": "11ca",
	"./icon-share.svg": "bcda",
	"./icon-signature-dark.svg": "ae95",
	"./icon-signature.svg": "dab2",
	"./icon-translate-dark.svg": "1fd8",
	"./icon-translate.svg": "c3e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edcb";